// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#dialog-overlay.ReadonlyListTable-dialog .dialog-container{\r\n    height: calc(100% - 35px);\r\n    width: calc(100% - 90px);\r\n    max-width: 100%;\r\n}\r\n#dialog-overlay.ReadonlyListTable-dialog .dialog-content{\r\n    padding: 0;\r\n    overflow: visible !important;\r\n}\r\n#dialog-overlay.ReadonlyListTable-dialog .table{\r\n    width: 100%;\r\n    height: calc(100% - 2px) !important;\r\n    margin: 0;\r\n}", ""]);
// Exports
module.exports = exports;
